import { useRouter } from 'next/router'

import useBootstrapData from '@/hooks/useBootstrapData'
import useContentfulSearchFormHeadlines from '@/hooks/useContentfulSearchFormHeadlines'

import { getTextString } from './SearchForm/utils'
import type { PackageFormTripType } from './types'

const primaryHeadlineText = 'Save up to $625 on your '

export default function usePackagesLandingFormContent(pageName: 'landing' | 'homepage') {
  const { query } = useRouter()
  const { isMobile, prePopData } = useBootstrapData()
  const searchForm = useContentfulSearchFormHeadlines('searchForm')
  const { tripType: prePopTripType, header } = prePopData?.packages ?? {}
  const shouldShowErrorBanner =
    pageName === 'landing' &&
    typeof query['redirect-source'] === 'string' &&
    query['redirect-source'].toLowerCase() === 'error'
  const contentfulHeadline = isMobile ? searchForm?.mobileHeadline : searchForm?.headline

  return {
    getHeadline: (tripType?: PackageFormTripType) =>
      header
        ? `Save big on bundles to ${header}`
        : contentfulHeadline || getTextString(tripType ?? prePopTripType ?? 'STAY:FLY')(primaryHeadlineText),
    shouldShowErrorBanner,
  }
}
